import * as React from 'react';
import { styled } from '@mui/material';

import { Header } from 'components/Header';
import { Footer } from 'components/Footer';
import CompDatabase from './CompDatabase';

const PageBody = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflowY: 'auto',
  background: 'rgba(250, 250, 250, 1)',
}));

const CompDatabasePage: React.FC = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }} data-testid="jobs-container">
      <Header />
      <PageBody>
        <CompDatabase />
      </PageBody>
      <Footer />
    </div>
  );
};

export default CompDatabasePage;
